import { useCallback, useState } from 'react';
import MasterComponentWraper from '../../Backend/MasterComponentWraper';
import NavigationHeder from '../../Navigations/NavigationHeder';
import ButtonNew from '../../inc/ButtonNew';
import AgGridNew from '../../grid/ag/ag-grid-new';
import AppMasterFormsPopup from './AppMasterFormsPopup';
import Api from '../../../inc/Api';
import { useNavigate } from 'react-router-dom';
import Settings from '../../../inc/Settings';
import { getPopupMessageBasedOnStatus } from '../../../inc/Validation';
import Helper from '../../../inc/Helper';
import { getLabelFromDropdown, gridLinkValueFormat } from '../../grid/ag/commonFunctions/GridCommonFunctions';
import DatepickerFunctions from '../../../inc/DatepickerHelper';
import SimpleDropdown from '../../grid/ag/cellEditor/SimpleDropdown';

let gridApi = null;
const AppMasterFormsListings = () => {
  const [openPopupView, setOpenPopupView] = useState(false);

  const navigate = useNavigate();

  const onClickRedirectToDetailView = (event) => {   
    if(event.colDef.field === 'app_name') { 
      navigate(`/edit-app-master-form/${event?.data?.app_id}`)
    }
  }

  const onClickPopupView = () => {
    setOpenPopupView(true);
  }

  const onDeleteIntegrationDocument = useCallback(async (element) => { 
    let api = Api;
    api.setUserToken();
    
    let delDocument_ID = element?.data?.app_id;

    try {
      const res = await api
      .axios()
      .delete(Settings.apiAppUrl+`/update/${delDocument_ID}/`)

      const rowNode = gridApi?.getRowNode(delDocument_ID)
      
      if (rowNode) {
        rowNode.setSelected(false)
      }
      
      setTimeout(() => {
        const transaction = { remove: [element.data] }
        gridApi?.applyServerSideTransaction(transaction) 
      }, 200);

      gridApi?.refreshServerSide({ purge: true })
      gridApi?.deselectAll();
      
      Helper.alert(res?.data?.message || 'App master deleted successfully', 'success')
    } catch (err) {
      getPopupMessageBasedOnStatus(err)
    }
  }, []);

  const reloadParentGrid = () => {
    gridApi?.refreshServerSide({ purge: true });
    gridApi?.deselectAll();
  };

  const gridColumnHeaders = [
    {field:'app_name', filter: 'agTextColumnFilter', headerName:'App name', editable:false, cellRenderer: (params) => gridLinkValueFormat(params) },
    {field:'app_description', headerName:'App description', editable: false },  
    {
      field: 'status',
      headerName: 'Status',
      editable: false, 
      isAllowZero:true,
      cellEditor: SimpleDropdown,
      minWidth:180,  
      cellEditorParams: {
        values: Settings.enumStatus
      },
      cellDataType:false,
      valueFormatter: (params) => getLabelFromDropdown(params)
    },
    {field:'base_url', headerName:'Base URL', editable: false },
    {field:'created_by', headerName:'Created by', editable: false },
    {field:'created_datetime', valueFormatter: (params) => params?.value ? DatepickerFunctions.convertDateTimeFromDataBase(params?.value) : '-', headerName:'Created date time', editable: false },
    {field:'modified_by', headerName:'Modified by', editable: false },
    {field:'modified_datetime', valueFormatter: (params) => params?.value ? DatepickerFunctions.convertDateTimeFromDataBase(params?.value) : '-', headerName:'Modified date time', editable: false },
  ];

  return (
    <div className='container-fluid'>
      <NavigationHeder hideMoreBtn={true} backUrl='/system-integration' title={'App Master'}>
        <ButtonNew onClick={onClickPopupView} title={'New'}  />
      </NavigationHeder>

      <AgGridNew
        apiUrl={Settings.apiAppUrl+'/details'} 
        pagination={true}
        columnDefs={gridColumnHeaders} 
        hideDeleteBtn={true}
        hideAddBtn={true}
        paginationPageSize={100}
        height={500}
        uniqueField={'app_id'}
        onCellClicked={onClickRedirectToDetailView}
        handleDeleteSelectedRows={onDeleteIntegrationDocument}
        onGridReady={(params) => gridApi = params?.api} 
        gridId={"app_master_forms_listing_grid"}
      />

      {openPopupView && <AppMasterFormsPopup reloadParentGrid={reloadParentGrid} setClosePopupViewModal={setOpenPopupView} />}
    </div>
  )
}

export default (MasterComponentWraper(AppMasterFormsListings));